module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_people_in_room-4b385e52954584e8e541147192a30bf3.svg";